import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { useCallback } from 'react';
import { topCompanyLogoData } from '@/components/modules/pages/top/contents/TopUseCompany/const';
import { TopSectionHead } from '@/components/modules/pages/top/typography/head/TopSectionHead';
import { ImageBase } from '@/components/ui/Image/ImageBase';
const animationStyle = css `
  animation: slide-loop 120s linear infinite;

  @keyframes slide-loop {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-100%);
    }
  }
`;
export const TopUseCompany = (props) => {
    const { className = '', companyRef } = props;
    const setRef = useCallback((current) => {
        if (current && companyRef) {
            companyRef.current = current;
        }
    }, [companyRef]);
    return (_jsxs("div", Object.assign({ className: clsx('bg-gray-100', 'pt-40 pb-60 lg:pb-[78px]', className), ref: setRef }, { children: [_jsx(TopSectionHead, Object.assign({ size: 'sm' }, { children: "\u3054\u5229\u7528\u4F01\u696D" })), _jsx("div", Object.assign({ className: clsx('w-full', 'mt-24 lg:mt-44', 'flex', 'overflow-hidden') }, { children: [1, 2].map((number) => (_jsx("ul", Object.assign({ className: clsx('shrink-0', 'flex items-center gap-x-20 lg:gap-x-40', 'pl-20 lg:pl-40'), css: animationStyle }, { children: topCompanyLogoData.map((logo) => (_jsx("li", Object.assign({ className: clsx('shrink-0', 'h-[20px] lg:h-[48px] w-auto max-w-[100px] lg:max-w-[180px]') }, { children: _jsx(ImageBase, { alt: logo.alt, imageHeight: logo.height, imageWidth: logo.width, isLazyLoad: false, objectPosition: 'contain', src: logo.src, webpSrc: logo.webpSrc }) }), `${number}_${logo.alt}`))) }), `TopUseCompany_list_${number}`))) }))] })));
};
